import { EmptyObject } from './EmptyObject';

export const EnableMonitoring = 'sos.Monitoring.EnableMonitoring';
export interface EnableMonitoring {
	type: typeof EnableMonitoring;
}

export const DisableMonitoring = 'sos.Monitoring.DisableMonitoring';
export interface DisableMonitoring {
	type: typeof DisableMonitoring;
}

export const AppletRefreshRequest = 'sos.Monitoring.AppletRefreshRequest';
export interface AppletRefreshRequest {
	type: typeof AppletRefreshRequest;
}

export const AppletRefreshResult = 'sos.Monitoring.AppletRefreshResult';
export interface AppletRefreshResult {
	type: typeof AppletRefreshResult;
	result: EmptyObject;
}

export const AppletRestoreRequest = 'sos.Monitoring.AppletRestoreRequest';
export interface AppletRestoreRequest {
	type: typeof AppletRestoreRequest;
}

export const AppletRestoreResult = 'sos.Monitoring.AppletRestoreResult';
export interface AppletRestoreResult {
	type: typeof AppletRestoreResult;
	result: EmptyObject;
}

export type AppletMonitoringRequests = EnableMonitoring | DisableMonitoring | AppletRefreshRequest | AppletRestoreRequest;
